"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.editReservation = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const actionLayout_1 = require("../../../../Table/columns/actionsColumn/actionLayout");
exports.editReservation = (0, actionLayout_1.createActionLayout)({
    text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Actions:Edit', defaultMessage: 'Edit' })),
    iconName: 'edit',
});
//# sourceMappingURL=editReservation.js.map